export const CCPA_ANALYTICS = "sunnywell_ccpa_analytics";
export const CCPA_MARKETING = "sunnywell_ccpa_marketing";
export const CCPA_PERSONALIZATION = "sunnywell_ccpa_personalization";
export const ACCESSIBILITY = "sunnywell_accessibility";
